import React from 'react';
import IconLabel from '../util/IconLabel';
import CapacitorRipple from './Ripple';
import styles from './BackButton.css';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../messages/Common';

const CapacitorBackButton = ({ intl }) => {
  const onClick = () => {
    window.EventChannelPlugin.simulateAndroidBackPress();
  };

  return (
    <button
      onClick={onClick}
      className={styles.button}
      aria-label={intl.formatMessage(commonMessages.back)}
    >
      <CapacitorRipple version="center" />
      <IconLabel name="arrow-left" className={styles.icon} size="medium" />
    </button>
  );
};

CapacitorBackButton.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CapacitorBackButton);
